module.exports = __webpack_public_path__ + "images/emails/logo-400-73beeae701ccfbd6383d25a8d968b307.png";